module.exports = (__webpack_require__(2339))(5927);